import React, { useEffect, useState, useRef } from 'react'
import { message, Spin } from 'antd'
import { useLockFn } from 'ahooks'
import { picProcess } from '../../../utils/image'
import { cdnImg } from '../../../utils/image'
import Modal from '../../modal'
import request from '../../../utils/request'
import FileTreeData from '../../../common/fileTreeData'
import { message as mes } from '../../../utils'
import Icon from '../../icon'
import globalData from '../../../common/globalData'
import TreeOption from '../../inspirationTreeList'
import Button from '../../../baseComponent/button'
import { renderCompat } from '../../../utils/renderCompat'
import styles from './index.module.less'

export default ({ className, style, onClickTrigger, blogs, blogId, blogIds, fromInspirationId, onChange }) => {
  const _onClickTrigger = (e) => {
    e && e.stopPropagation()
    renderMoveImage({
      blogs,
      blogIds,
      onChange,
      fromInspirationId,
    })
    onClickTrigger?.()
  }
  return (
    <Button className={className} style={style} onClick={_onClickTrigger} disabled={!blogId && !blogIds.length} type="primary">
      移动
    </Button>
  )
}

export const renderMoveImage = (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    renderCompat(<MoveImage {...props} visible container={div} />, div)
  })
}

const MoveImage = ({
  visible,
  blogId,
  blogs = [],
  blog = {},
  fromInspirationIdList = [],
  fromInspirationId,
  hasMove = true,
  url = '/zhikuan/ins/inspiration/move-blogs-to-inspiration', // /update-quick-collect-inspiration
  onCancel,
  onOk,
  onChange,
}) => {
  const isAllMove = !!fromInspirationIdList?.length
  const [repeatInfos, setRepeatInfos] = useState([])
  const [_visible, set_Visible] = useState(visible)
  const [treeOption, setTreeOption] = useState([])
  const [loading, setLoading] = useState(false)
  const [moreLoading, setMoreLoading] = useState(false)
  const [repeatIds, setRepeatIds] = useState([])
  const [repeatVisible, setRepeatVisible] = useState(false)
  const [repeatIndex, setRepeatIndex] = useState(0)
  const [toIdeaMass, setToIdeaMass] = useState({})

  const [hasReserveValue, setHasReserveValue] = useState(false)
  const treeData = useRef(null)

  const [keyWords, setKeyWords] = useState()
  const pageParams = useRef({
    start: 0,
    pageSize: 20,
  })
  const resultList = useRef([])
  const totalRef = useRef(0)

  useEffect(() => {
    if (!visible) {
      setRepeatIndex(0)
    }
  }, [visible])

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }
  const _ok = async () => {
    const flag = await onOk?.()
    if (flag === false) {
      return
    }
    set_Visible(false)
  }

  useEffect(() => {
    globalData.toGet('move-image-has-reserve').then((result) => {
      if (result) {
        setHasReserveValue(JSON.parse(result))
      }
    })
    fetchData()
  }, [])

  const fetchData = async (_keyWords = keyWords, _pageParams = pageParams.current) => {
    setLoading(true)
    const res = await request.post('/zhikuan/ins/inspiration/list-collect-inspiration-tree', {
      ..._pageParams,
      likeName: _keyWords,
    })
    totalRef.current = res.resultCount
    const tempResult =
      _pageParams.start === 0
        ? (resultList.current = res.resultList)
        : (resultList.current = [...resultList.current, ...res.resultList])
    treeData.current = new FileTreeData({
      data: tempResult,
      childrenKey: 'childs',
    })
    treeData.current.checkMoveAllMarkStatus(fromInspirationId)
    setTreeOption(treeData.current.data)
    setLoading(false)
  }

  // 重复替换
  const fetchRepeat = async (toInspirationId) => {
    try {
      const res = await request.post(
        '/zhikuan/ins/inspiration/query-blog-is-collect',
        {
          blogIdList: blogId ? [blogId] : blogs.map((m) => m.imageGroupEntityId),
          inspirationId: toInspirationId,
        },
        { status: true }
      )
      setRepeatInfos(res.param)
      setRepeatIds(res.result)
      return res.result
    } catch (err) {
      console.error('query-blog-is-collect', err)
    }
  }

  const replace = async (id) => {
    setRepeatIds((pre) => pre.filter((m) => m !== id))
    let blogParamList
    if (blogId) {
      blogParamList = [{ blogId, fromInspirationId }]
    } else if (blogs.length) {
      blogParamList = blogs.map((m) => ({ blogId: m.imageGroupEntityId, fromInspirationId: m.inspirationId }))
    }
    blogParamList = blogParamList.filter((m) => m.blogId === id)
    try {
      await request.post(url, {
        blogParamList,
        toInspirationId: toIdeaMass.id,
        copy: hasMove ? (hasReserveValue ? 1 : 0) : null,
      })
      if (repeatIds.length === 1) {
        setRepeatVisible(false)
        const flag = fromInspirationId ? includeNode(toIdeaMass.id, fromInspirationId) : false
        onChange && onChange(blogId, flag, hasReserveValue)
        message.success(
          <span>
            已成功移动至
            <a
              className="mn-link"
              href={`/meinian/home/coll/detail/${toIdeaMass.id}?inspirationId=${toIdeaMass.id}`}
              target="_blank"
              rel="noreferrer"
            >
              {toIdeaMass.name}
            </a>
          </span>
        )
      }
    } catch (err) {
      console.error('move-blogs-to-inspiration', err)
    }
  }

  const replaceAll = async () => {
    let blogParamList
    if (blogId) {
      blogParamList = [{ blogId, fromInspirationId }]
    } else if (blogs.length) {
      blogParamList = blogs.map((m) => ({ blogId: m.imageGroupEntityId, fromInspirationId: m.inspirationId }))
    }
    blogParamList = blogParamList.filter((m) => repeatIds.includes(m.blogId))
    try {
      await request.post(url, {
        blogParamList,
        toInspirationId: toIdeaMass.id,
        copy: hasMove ? (hasReserveValue ? 1 : 0) : null,
      })
      setRepeatVisible(false)
      set_Visible(false)
      const flag = fromInspirationId ? includeNode(toIdeaMass.id, fromInspirationId) : false
      onChange && onChange(blogId, flag, hasReserveValue)
      message.success(
        <span>
          已成功移动至
          <a
            className="mn-link"
            href={`/meinian/home/coll/detail/${toIdeaMass.id}?inspirationId=${toIdeaMass.id}`}
            target="_blank"
            rel="noreferrer"
          >
            {toIdeaMass.name}
          </a>
        </span>
      )
    } catch (err) {
      console.error('move-blogs-to-inspiration', err)
    }
  }

  const allMove = async (toInspirationId) => {
    setMoreLoading(true)
    return new Promise(async (resolve) => {
      try {
        const result = await request.post(url, {
          fromInspirationIdList,
          toInspirationId,
          copy: 0,
        })
        resolve({
          error: false,
          data: result,
        })
        setMoreLoading(true)
      } catch (err) {
        resolve({
          error: err,
        })
        setMoreLoading(false)
      }
    })
  }

  const move = async (_repeatIds = [], toInspirationId) => {
    let blogParamList = blogId
      ? [{ blogId, fromInspirationId }]
      : blogs.map((m) => ({ blogId: m.imageGroupEntityId, fromInspirationId: m.inspirationId }))
    if (_repeatIds.length) {
      blogParamList = blogParamList.filter((m) => !_repeatIds.includes(m.blogId))
    }
    if (!blogParamList.length) {
      return
    }
    try {
      await request.post(url, {
        blogParamList,
        toInspirationId,
        copy: hasMove ? (hasReserveValue ? 1 : 0) : null,
      })
    } catch (err) {
      console.error('move-blogs-to-inspiration', err)
      return err
    }
  }

  const onMoveSuccess = (toInspiration) => {
    const curItem = treeData.current.findNodeByValue(toInspiration.id)
    let linkUrl = ''
    if (curItem.parent) {
      linkUrl = `/meinian/home/coll/detail/${toInspiration.id}?inspirationId=${toInspiration.id}&parentId=${curItem.parent.value}&name=${curItem.current.label}`
    } else {
      linkUrl = `/meinian/home/coll/detail/${toInspiration.id}?inspirationId=${toInspiration.id}`
    }
    message.success(
      <span>
        已成功移动至
        <a className="mn-link" href={linkUrl} target="_blank" rel="noreferrer">
          {toInspiration.name}
        </a>
      </span>
    )
    const flag = fromInspirationId ? includeNode(toInspiration.id, fromInspirationId) : false
    setTimeout(() => {
      onChange?.(blogId, flag, hasReserveValue)
    })
  }

  const onMove = useLockFn(async (toInspiration) => {
    if (isAllMove) {
      const { error } = await allMove(toInspiration.id)
      if (!error) {
        onMoveSuccess(toInspiration)
      }
    } else {
      const ids = await fetchRepeat(toInspiration.id)
      if (ids.length) {
        setToIdeaMass(toInspiration)
        setRepeatVisible(true)
        set_Visible(false)
        return
      }
      const moveRes = await move(ids, toInspiration.id)
      if (moveRes) {
        mes.pub('onMNUploadImage')
        set_Visible(false)
        return
      }
      onMoveSuccess(toInspiration)
    }
    set_Visible(false)
  })

  const includeNode = (toInspirationId, _fromInspirationId) => {
    const root = treeData.current.getRootByValue(_fromInspirationId)
    if (toInspirationId === root?.value) {
      return true
    }
    const flag = treeData.current.someIsChild(toInspirationId, root.value)
    return flag
  }

  const getMainUrl = (index = 0) => {
    return (
      blog?.mainUrl ||
      blogs.find((m) => m.imageGroupEntityId === repeatIds[repeatIndex + index])?.mainUrl ||
      repeatInfos?.[repeatIndex + index]?.value
    )
  }

  return (
    <>
      <Modal
        onCancel={_cancel}
        onOk={_ok}
        visible={_visible}
        style={{ width: '640px', borderRadius: '3px' }}
        title={<span style={{ fontSize: 20, color: 'var(--m-text-1)' }}>移动到灵感集</span>}
        hiddenFooter
        className={styles['mn-move-image-modal']}
      >
        <Spin
          spinning={moreLoading}
          indicator={
            <div style={{ width: 'max-content', color: 'var(--m-text-2)', transform: 'translateX(-28px)' }}>正在移动......</div>
          }
        >
          <div className={styles['move-image-modal-content']}>
            <TreeOption
              onLoad={() => {
                pageParams.current.start += 20
                if (pageParams.current.start < totalRef.current) {
                  fetchData()
                }
              }}
              keyWords={keyWords}
              onKeyWords={(val) => {
                pageParams.current.start = 0
                fetchData(val)
                setKeyWords(val)
              }}
              collectBtn="移动"
              singleCollection
              hasMove={hasMove}
              hasReserveValue={hasReserveValue}
              hasCollectChange={false}
              onHasReserveChange={(e) => {
                globalData.set('move-image-has-reserve', e.target.checked)
                setHasReserveValue(e.target.checked)
              }}
              onItemCollect={(inspirationId, inspiration) => onMove(inspiration)}
              onChooseTaskClose={_cancel}
              onChooseTaskOk={_cancel}
              onCancel={_cancel}
              treeData={treeData.current}
              data={treeOption}
              scrollHeight="calc(100vh - 282px)"
              loading={loading}
              onCreateInspiration={(_id, _name, _current) => onMove(_current)}
            />
          </div>
        </Spin>
      </Modal>
      {repeatVisible ? (
        <Modal
          visible={repeatVisible}
          onVisibleChange={(_repeatVisible) => setRepeatVisible(_repeatVisible)}
          onClose={() => onChange?.(blogId, false, hasReserveValue)}
          title={
            <>
              <Icon type="m-zhuyi_tianchong" style={{ color: '#ED7E28' }} />
              提醒
            </>
          }
          style={{ width: 480 }}
          footer={
            <>
              <Button
                ghost
                style={{ width: 88 }}
                onClick={() => {
                  setRepeatVisible(false)
                }}
              >
                取消
              </Button>
              {!blogId ? (
                <Button ghost style={{ marginLeft: 8 }} onClick={() => replaceAll()}>
                  全部替换
                </Button>
              ) : null}
              {!blogId && repeatIndex < repeatIds.length - 1 ? (
                <Button
                  ghost
                  style={{ width: 88, marginLeft: 8 }}
                  onClick={() => setRepeatIds((pre) => pre.filter((m) => m !== repeatIds[repeatIds.length - 1]))}
                >
                  下一个
                </Button>
              ) : null}
              <Button other style={{ width: 88, marginLeft: 8 }} onClick={() => replace(repeatIds[repeatIndex])}>
                替换
              </Button>
            </>
          }
        >
          <div className={styles['mn-move-image-repeat']}>
            <div className="text">
              该灵感集中已经存在相同的款式图，你要使用正在移动的款式图来替换它吗？选择替换后，相关的批注、评论及款式升级信息均会以新款式图的信息为准。
            </div>
            <div className="images">
              {repeatIds?.[2] && (
                <div className="image-3">
                  <img src={cdnImg(getMainUrl(2), 200)} />
                </div>
              )}
              {repeatIds?.[1] && (
                <div className="image-2">
                  <img src={cdnImg(getMainUrl(1), 200)} />
                </div>
              )}
              {repeatIds[0] && <img className="image-1" style={{ right: blogId ? 136 : 88 }} src={picProcess(getMainUrl(0))} />}
            </div>
          </div>
        </Modal>
      ) : null}
    </>
  )
}
